var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hand',{attrs:{"hand":_vm.hand}}),_c('button',{staticClass:"btn",on:{"click":_vm.newHand}},[_vm._v("new hand")]),_c('button',{staticClass:"btn",on:{"click":_vm.draw}},[_vm._v("draw")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }